import type { KeyboardEvent, ReactNode } from 'react'

type CardProps = {
  title?: ReactNode | string
  subtitle?: ReactNode | string
  children?: ReactNode
  onClick?: () => void
  onKeyDown?: (event: KeyboardEvent<HTMLDivElement>) => void
  className?: string
  isHoverable?: boolean
}

export const Card = ({ title, subtitle, children, onClick, onKeyDown, className = '', isHoverable }: CardProps) => {
  const handleClick = () => {
    if (onClick) {
      onClick()
    }
  }

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (onKeyDown) {
      onKeyDown(e)
      return
    }
    if ((e.key === 'Enter' || e.key === ' ') && onClick) {
      e.preventDefault()
      onClick()
    }
  }

  const hoverable = isHoverable ?? !!onClick

  return (
    <div
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      className={`ap:bg-surface-primary ap:min-h-4xl ap:rounded-md ap:shadow-soft ${
        hoverable ? 'ap:cursor-pointer ap:hover:bg-surface-accent' : ''
      } ${className}`}
    >
      {(title || subtitle) && (
        <div className="ap:flex ap:flex-col ap:justify-center">
          <h2 className="ap:text-[20px] ap:font-semibold ap:text-content-primary">{title}</h2>
          {subtitle && <p className="ap:text-sm ap:font-normal ap:text-content-secondary">{subtitle}</p>}
        </div>
      )}
      {children}
    </div>
  )
}
